import { createTheme, Theme } from "@mui/material/styles";
import { themeColors } from "./colors";

// See https://mui.com/material-ui/customization/palette/

export const defaultTheme: Theme = createTheme({
  palette: {
    mode: "dark",
    primary: {
      main: themeColors.primary.main,
    },
    secondary: {
      main: themeColors.secondary.main,
    },
    background: {
      default: themeColors.background.default,
      paper: themeColors.background.paper,
    },
    text: {
      primary: themeColors.text.primary,
      secondary: themeColors.text.secondary,
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          backgroundColor: themeColors.background.default,
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          color: "#e8e8e8", // Bright text for table cells
          borderBottom: "1px solid rgba(255, 255, 255, 0.1)",
        },
        head: {
          color: "#f5f5f5", // Even brighter for headers
          fontWeight: 600,
          backgroundColor: "#2d2d2d",
        },
      },
    },
    MuiTable: {
      styleOverrides: {
        root: {
          backgroundColor: "#242424",
        },
      },
    },
    MuiTableRow: {
      styleOverrides: {
        root: {
          "&:hover": {
            backgroundColor: "rgba(255, 255, 255, 0.05)",
          },
        },
      },
    },
  } as any,
});

// Apply DataGrid styles after theme creation
if (defaultTheme.components) {
  (defaultTheme.components as any).MuiDataGrid = {
    styleOverrides: {
      root: {
        border: "none",
        "& .MuiDataGrid-cell": {
          color: "#e8e8e8",
          borderBottom: "1px solid rgba(255, 255, 255, 0.1)",
        },
        "& .MuiDataGrid-columnHeaders": {
          backgroundColor: "#2d2d2d",
          color: "#f5f5f5",
          borderBottom: "1px solid rgba(255, 255, 255, 0.15)",
        },
        "& .MuiDataGrid-columnHeaderTitle": {
          color: "#f5f5f5",
          fontWeight: 600,
        },
        "& .MuiDataGrid-row": {
          "&:hover": {
            backgroundColor: "rgba(255, 255, 255, 0.05)",
          },
        },
        "& .MuiDataGrid-footerContainer": {
          borderTop: "1px solid rgba(255, 255, 255, 0.1)",
          color: "#e0e0e0",
        },
        "& .MuiTablePagination-root": {
          color: "#e0e0e0",
        },
        "& .MuiIconButton-root": {
          color: "#b0b0b0",
        },
        "& a": {
          color: "#90caf9",
          textDecoration: "none",
          "&:hover": {
            textDecoration: "underline",
          },
        },
      },
    },
  };
}
